// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__HgzUd","calendarButtons":"ClockData_calendarButtons__3bxJC"};